(() => {
  document.querySelectorAll('[data-thf-tools]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('dialog');
    const form = root.querySelector('form');
    const opener = root.querySelector('.thf-filter-open');
    const query = new URL(location.href).searchParams;
    for (const field of form.elements) {
      if (!field.name) continue;
      if (field.name.startsWith('filter.')) {
        if (field.type === 'radio') field.checked = field.value === (query.get(field.name) || '');
        else field.value = query.get(field.name) || '';
      }
    }
    for (const name of ['stone','colour','metal','design']) {
      if (!form.querySelector(`input[name="${name}"]:checked`)) {
        const all = form.querySelector(`input[name="${name}"][value=""]`);
        if (all) all.checked = true;
      }
    }
    opener.addEventListener('click', () => { dialog.showModal(); document.body.classList.add('thf-filters-open'); });
    root.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { document.body.classList.remove('thf-filters-open'); opener.focus(); });
    dialog.addEventListener('click', e => { if(e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dialog.close(); } });
    form.addEventListener('submit', e => {
      e.preventDefault();
      const data = new FormData(form);
      const lower = data.get('filter.v.price.gte'), upper = data.get('filter.v.price.lte');
      const maxField = form.elements.namedItem('filter.v.price.lte');
      maxField.setCustomValidity(lower && upper && Number(lower)>Number(upper) ? 'Enter a maximum price above the minimum.' : '');
      if (!form.reportValidity()) return;
      const tags = [...form.querySelectorAll('[data-tag]:checked')].map(i=>i.value).filter(Boolean);
      const destination = new URL(root.dataset.collectionUrl + (tags.length ? '/' + tags.join('+') : ''), location.origin);
      const params = new URLSearchParams(location.search); params.delete('page');
      for (const name of ['filter.v.availability','filter.v.price.gte','filter.v.price.lte']) {
        params.delete(name); if (data.get(name)) params.set(name,data.get(name));
      }
      destination.search=params.toString(); location.assign(destination.href);
    });
    form.addEventListener('input',()=>form.elements.namedItem('filter.v.price.lte').setCustomValidity(''));
    root.querySelectorAll('[data-sort]').forEach(button=>button.addEventListener('click',()=>{
      const destination = new URL(location.href); destination.searchParams.set('sort_by',button.dataset.sort); destination.searchParams.delete('page'); location.assign(destination.href);
    }));
    const grid=document.querySelector('#product-grid');
    const setGrid=value=>{ if(!grid) return; grid.dataset.thfGrid=value; root.querySelectorAll('[data-grid]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.grid===value))); };
    root.querySelectorAll('[data-grid]').forEach(button=>button.addEventListener('click',()=>setGrid(button.dataset.grid)));
    setGrid('compact');
    document.addEventListener('click',e=>{const sort=root.querySelector('.thf-sort'); if(!sort.contains(e.target))sort.open=false;});
    root.querySelector('.thf-sort').addEventListener('keydown',e=>{if(e.key==='Escape'){e.currentTarget.open=false;e.currentTarget.querySelector('summary').focus();}});
  });
})();
